{
  "login": {
    "title": "Sign in",
    "subtitle": "Ward³ SOC console",
    "email": "Email",
    "email_placeholder": "you@example.com",
    "password": "Password",
    "password_placeholder": "Your password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "error_invalid": "Invalid email or password",
    "error_server": "Server error — please retry",
    "error_oidc": "SSO sign-in failed",
    "use_oidc": "Sign in with {{provider}}",
    "use_local": "Or sign in with your password",
    "tenant_scope": "Tenant {{tenant}} at MSSP {{mssp}}",
    "mssp_scope": "MSSP {{mssp}}",
    "no_scope": "No tenant scope detected",
    "mssp_slug_label": "MSSP slug (optional)",
    "mssp_slug_placeholder": "acme-security",
    "tenant_slug_label": "Tenant slug (optional)",
    "tenant_slug_placeholder": "bank-eu-1",
    "sso_button_default": "Sign in with SSO",
    "sso_divider": "or local",
    "break_glass_prefix": "You can force local auth (break-glass) via",
    "break_glass_suffix": ".",
    "oidc_mssp_required": "MSSP slug required for OIDC.",
    "generic_failure": "Login failed"
  },
  "logout": {
    "button": "Logout",
    "title": "Sign out of this session"
  },
  "profile": {
    "title": "Profile",
    "subtitle": "Account preferences",
    "email": "Email",
    "role": "Role",
    "scope": "Scope",
    "language": "Interface language",
    "language_help": "Applied immediately. Persisted to your account.",
    "save_error": "Could not save your preference — please retry",
    "back_to_app": "Back to dashboard"
  },
  "status": {
    "authenticating": "Authenticating…",
    "system_nominal": "System Nominal",
    "lstm_active": "LSTM Judge active",
    "gnn_active": "GNN Judge active",
    "shadow_active": "Shadow Mode collecting flows",
    "user_uuid": "User UUID {{uuid}}",
    "open_navigation": "Open navigation",
    "close_navigation": "Close navigation",
    "expand_sidebar": "Expand sidebar",
    "collapse_sidebar": "Collapse sidebar"
  },
  "forbidden": {
    "admin_required": "Admin role required",
    "platform_required": "Platform role required",
    "mssp_required": "MSSP role required",
    "role_not_allowed": "Role {{role}} not allowed here"
  },
  "errors": {
    "forbidden_admin": "403 — this console is restricted to platform / MSSP operators."
  }
}
